import type { ConditionType } from '@validators/types'

export const mainCustomer: ConditionType = {
	name: {
		rules: ['require', 'isUserName', 'isLength[{"min": 0, "max": 20}]'],
		message: {
			require: 'Name is a required field.',
			isUserName: 'Only letters and spaces are allowed in the name field.',
			isLength: 'Please enter within 20 characters.',
		},
	},
	email: {
		rules: ['require', 'isEmail'],
		message: {
			require: 'Email is a required field.',
			isEmail: 'Please enter the email format in the email field.',
		},
	},
	password: {
		rules: ['require', 'password', 'isLength[{"min": 8, "max": 20}]'],
		message: {
			require: 'Password is a required field.',
			password:
				'Password is not password format.English + Number + Special Charactors(!@#$%^*+=-)',
			isLength: 'Please enter 8 to 20 characters in password field.',
		},
	},
}

export default mainCustomer
